import { Controller } from "@hotwired/stimulus"
import { confirmDialog } from "../helpers/swal_helper"

export default class extends Controller {
  static targets = ["content", "itemSelect"]

  submitNote(event) {
    if (event.key !== 'Enter') return

    const content = this.contentTarget.value.trim()
    if (!content) return

    event.preventDefault()

    const itemId = this.itemSelectTarget.value
    const enrolmentId = this.data.get("enrolmentIdValue")

    let commentableId, commentableType

    if (itemId && itemId !== '') {
      commentableId = itemId
      commentableType = 'EnrolmentItem'
    } else {
      commentableId = enrolmentId
      commentableType = 'Enrolment'
    }

    const formData = new FormData()
    formData.append('content', content)
    formData.append('commentable_id', commentableId)
    formData.append('commentable_type', commentableType)

    Rails.ajax({
      type: 'POST',
      url: '/user_comments',
      data: formData,
      success: () => {
        $.notify('Note added successfully', 'success')
        this.contentTarget.value = ''
        window.location.reload()
      },
      error: () => {
        $.notify('Failed to add note', 'danger')
      }
    })
  }

  async deleteNote(event) {
    const noteId = event.currentTarget.dataset.noteId
    const confirmed = await confirmDialog({ text: 'Are you sure you want to delete this note?' })

    if (!confirmed) return

    Rails.ajax({
      type: 'DELETE',
      url: `/user_comments/${noteId}`,
      success: () => {
        $.notify('Note deleted successfully', 'success')
        window.location.reload()
      },
      error: () => {
        $.notify('Failed to delete note', 'danger')
      }
    })
  }
}
